import { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import orgJson from "components/jsonData/orgnization.json";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { AiFillDelete } from "react-icons/ai";
import { fetchAsyncDeleteModuleType } from "redux/organizationModuleSlice";
import { MdModeEdit } from "react-icons/md";
import { getSeletedIcon } from "./moduleIcon";
import AddModuleForm from "./addModuleForm";
import { FaPlusCircle } from "react-icons/fa";

const { Box, Button, Table, Thead, Tr, Th, Tbody, Td } = require("@chakra-ui/react");

const OrganizationModuleTypeForm = ({
  handleRefresh,
  allModule
}) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [isEdit,setIsEdit] = useState(false)
  const [editData,setEditData] = useState({})
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = ()=>{
    setIsOpen(false);
    setIsEdit(false);
    setEditData("")
    handleRefresh()
  }
  const handleDeleteModule = async(e, item) => {
    e.preventDefault();
    const confirmationMessage = orgJson.confirm.deleteModule;
    const title = confirmationMessage.replace("{itemName}", item?.name);
    ConfirmationDialog({
      title: title,
      text: orgJson.text.undone,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        dispatch(fetchAsyncDeleteModuleType(item?._id)).then((res) => {
          if(res?.payload){
            handleRefresh();
            addToast('Module Deleted Successfully!', { appearance: "success" });
          }
          else{
            addToast(res?.error?.message, { appearance: "error" });
          }
        }).catch((err)=>{
          addToast('An error occurred. Please try again.', { appearance: "error" });

        })
      },
      
    });
  };
  
  const handleEditClick = (e,data)=>{
    e.preventDefault();
    setIsEdit(true)
    setEditData(data)
    setIsOpen(true)
  }
  
  return (
    <>
     <Form className="addForm m-3 mt-5">
        <div className="form-card">
            <Box display="flex">

          <h5 className="mt-">Expense Module</h5>
          <Button className="mt-0 add-user-btn" onClick={() => setIsOpen(true)}>
            <FaPlusCircle className="add-project-icon" size={15} />
          </Button>
            </Box>
         
        </div>
      </Form>
      <div className="module-table">
        <Table className="field-table">
          <Thead>
            <Tr>
              <Th className="number">No.</Th>
              <Th className="module-name">Module Name</Th>
              <Th className="module-type">Type</Th>
              <Th className="prifix">Prifix</Th>
              <Th className="chart-color">Chart Color</Th>
              <Th className="chart-icon">Icon</Th>
              <Th className="chart-action">Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {allModule && allModule.length ? allModule.map((item,index)=>{
              return (
                <Tr>
                  <Td className="number">{index + 1}</Td>
                  <Td className="module-name">{item.name}</Td>
                  <Td className="module-type">{item.typ}</Td>
                  <Td className="prifix">
                    {item.prfx} , {item?.poPrfx}
                  </Td>
                  <Td className="chart-color chart-data">
                    <input type="color" disabled value={item.clr} />
                  </Td>
                  <Td className="chart-icon">
                     {
                      item?.icnImg && getSeletedIcon(item.icnImg) ? 
                      getSeletedIcon(item.icnImg) : "-"
                     }
                  </Td>
                  <Td className="chart-action">
                    <div className="d-flex mx-2">
                      <MdModeEdit
                        className="me-1"
                        size={16}
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          handleEditClick(e, item);
                        }}
                      />
                      <AiFillDelete
                        style={{
                          cursor: "pointer",
                          color: "#c3473e",
                          marginLeft: "7px",
                        }}
                        size={16}
                        onClick={(e) => {
                          handleDeleteModule(e, item);
                        }}
                      />
                    </div>
                  </Td>
                </Tr>
              );
            }):
            ""
          }
          </Tbody>
        </Table>
      </div>
      {isOpen && (
          <AddModuleForm
            isOpen={isOpen}
            onClose={handleClose}
            isEdit={isEdit}
            editData={editData}
          />
        )}
    </>
  );
};

export default OrganizationModuleTypeForm;
